import { type ReactElement } from 'react';
import { MenuItem } from '@mui/material';

export type ItemProps = React.ComponentProps<typeof MenuItem>;

export const Item = (props: ItemProps): ReactElement => {
  return <MenuItem {...props} disableRipple />;
};
